import script from "./Otp.vue?vue&type=script&setup=true&lang=js"
export * from "./Otp.vue?vue&type=script&setup=true&lang=js"

import "./Otp.vue?vue&type=style&index=0&id=725ae014&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-725ae014"]])

export default __exports__